import { Component, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { VirtualOfficeService } from '../../../services/virtual-office.service'
import { CommonService } from '../../../services/common.service'
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';
import { ModalHelpComponent } from '../modal-help/modal-help.component';
import { ModalAcceptComponent } from '../modal-accept/modal-accept.component';
import { ModalBackComponent } from '../modal-back/modal-back.component';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { ModalViewComponent } from '../modal-view/modal-view.component';
import { ModalHelpInvoiceComponent } from '../modal-help-invoice/modal-help-invoice.component';
import { ModalSendMailComponent } from '../modal-send-mail/modal-send-mail.component';
import { EnvironmentService } from '../../../services/environment.service';
import { MeterReadingDownloadPdf, MeterReadingInsert } from '../../../models/meter-reading-insert';
import { ModalTerminosComponent } from '../modal-terminos/modal-terminos.component';
import { ModalPoliticasComponent } from '../modal-politicas/modal-politicas.component';
import { HtmlPolicy } from 'src/app/models/html-policy';
import { DomSanitizer } from '@angular/platform-browser';
import Swal from 'sweetalert2';
import { DataPrivacy1LogInsertDTO } from 'src/app/models/privacity-data-insert';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class MainComponent implements OnInit {
  @ViewChild('stepper', { read: MatHorizontalStepper, static: false }) stepper: MatHorizontalStepper;

  clientForm: FormGroup;
  meterReadingForm: FormGroup;

  handBookImage: string;
  billImage: string;
  privacyPolicy: HtmlPolicy;
  termsAndConditions: HtmlPolicy;

  installationNumber: string;
  interlocutorId: string;
  fullName: string;
  today: Date;
  operationNumber: string;
  operationId: string;

  showSample: boolean = true;
  title: string = 'Valida tus datos';
  steps = 1;
  docs = [
    { value: 'PE2', description: 'DNI' },
    { value: 'PE3', description: 'CE' },
    { value: 'PE5', description: 'Pasaporte' },
    {
      value: 'PE1', description: 'RUC'
    }
  ];

  filename: string;
  notify: boolean = false;
  captchaKey: string;
  documentNumberMaxlength: number = 1;
  documentNumberMinlength: number = 1;
  bloqueo: boolean = false;
  imageUpload: any;
  alerta: any;
  nextDate: string;
  isHiddenCommerce = false;
  Token = ''
  constructor(
    private formBuilder: FormBuilder,
    private virtualOfficeService: VirtualOfficeService,
    public dialog: MatDialog,
    private commonService: CommonService,
    private environmentService: EnvironmentService,
    private domSanitizer: DomSanitizer
  ) {
    this.captchaKey = this.environmentService.captchaKey;
    console.log('-------- --------')
    console.log(this.captchaKey)
  }
  async ngOnInit() {
    this.virtualOfficeService.getMensajeAlerta().then(p => {
      this.alerta = p;
      if (this.alerta.activo === 1) {
        this.bloqueo = true;
      }
    });


    this.getImages();
    this.getHtml();
    this.createClientForm();
    this.createMeterReadingForm();
  }
  validar() {
    if (this.bloqueo) {

      Swal.showLoading();
      Swal.fire({
        title: this.alerta.descHead,
        html: this.alerta.descBody + '</br></br>' + this.alerta.descFoot,
        confirmButtonText: "Aceptar",
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      }).then(f => {
        Swal.hideLoading();
      })

    }
  }
  openPolicyModal(policy: number) {
    //validacion 
    if (this.bloqueo) {

      Swal.showLoading();
      Swal.fire({
        title: this.alerta.descHead,
        html: this.alerta.descBody + '</br></br>' + this.alerta.descFoot,
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      }).then(f => {
        Swal.hideLoading();
      })
      return;
    }

    const dialogRef = this.dialog.open(ModalPoliticasComponent, {
      width: '800px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true
    });
    dialogRef.componentInstance.title = this.domSanitizer.bypassSecurityTrustHtml(policy == 1 ? this.privacyPolicy.title : this.termsAndConditions.title);
    dialogRef.componentInstance.body = this.domSanitizer.bypassSecurityTrustHtml(policy == 1 ? this.privacyPolicy.body : this.termsAndConditions.body);
  }
  async getImages() {
    this.handBookImage = await (await this.virtualOfficeService.getImageUrl('MANUAL_LECTURA_MEDIDOR_LECTURA')).data;
    this.billImage = await (await this.virtualOfficeService.getImageUrl('RECIBO_LECTURA_MEDIDOR_LECTURA')).data;
    // this.openDialogHelp2()
  }
  async getHtml() {
    this.privacyPolicy = await (await this.virtualOfficeService.getHtmlPolicy('POLITICA_PRIVACIDAD_LECTURA_MEDIDOR')).data;
    this.termsAndConditions = await (await this.virtualOfficeService.getHtmlPolicy('TERMINOS_CONDICIONES_LECTURA_MEDIDOR')).data;
  }
  createClientForm() {
    this.clientForm = this.formBuilder.group({
      documentType: [null, [Validators.required]],
      documentNumber: [{ value: null, disabled: true }, [Validators.required]],
      clientCode: [null, [Validators.required, Validators.maxLength(12)]],
      clauseAccepted: [false, [Validators.requiredTrue]],
      captcha: [null, Validators.required]
    });
  }
  documentTypeChanged(event) {
    switch (event.value) {
      case 'PE2':
        this.clientForm.get('documentNumber').enable();
        this.documentNumberMaxlength = 8;
        this.documentNumberMinlength = 8;
        this.clientForm.get('documentNumber').setValidators([Validators.required, RxwebValidators.numeric({ allowDecimal: false }), Validators.minLength(8), Validators.maxLength(8)]);
        break;
      case 'PE3':
        this.clientForm.get('documentNumber').enable();
        this.documentNumberMaxlength = 12;
        this.documentNumberMinlength = 9;

        this.clientForm.get('documentNumber').setValidators([Validators.required, Validators.minLength(this.documentNumberMinlength), Validators.maxLength(12)]);
        break;
      case 'PE5':
        this.clientForm.get('documentNumber').enable();
        this.documentNumberMaxlength = 12;
        this.clientForm.get('documentNumber').setValidators([Validators.required, RxwebValidators.numeric({ allowDecimal: false }), Validators.minLength(12), Validators.maxLength(12)]);
        break;
      case 'PE1':
        this.clientForm.get('documentNumber').enable();
        this.documentNumberMaxlength = 11;
        this.clientForm.get('documentNumber').setValidators([Validators.required, RxwebValidators.numeric({ allowDecimal: false }), Validators.minLength(11), Validators.maxLength(11)]);
        break;
    }
    this.clientForm.get('documentNumber').updateValueAndValidity();
  }
  createMeterReadingForm() {
    this.meterReadingForm = this.formBuilder.group({
      value: [null, [Validators.required, RxwebValidators.numeric({ allowDecimal: true }), Validators.maxLength(5)]],
      base64Image: [null, [Validators.required]],
      imagePath: [null, [Validators.required]],
      commerceAccepted: [null, null]
    });
  }
  async goToThirdStep() {
    if (this.meterReadingForm.valid) {
      const dialogRef = this.dialog.open(ModalAcceptComponent, {
        data: {
          subject: '¿Estás seguro de realizar esta operación?'
        },
        width: '400px',
        autoFocus: false,
        panelClass: 'dialog-custom-2',
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(async result => {
        if (result) {
          this.imageUpload = this.meterReadingForm.get('base64Image').value;
          let data = new MeterReadingInsert(this.clientForm.get('clientCode').value,
            this.fullName,
            this.installationNumber,
            this.interlocutorId,
            this.meterReadingForm.get('value').value,
            this.meterReadingForm.get('base64Image').value,
            'LEC',
            this.clientForm.get('documentNumber').value,
            this.Token
          )
          let response = await this.virtualOfficeService.insertMeterReading(data);
          if (response.valid) {
            this.today = new Date();
            this.operationId = response.data.operationId;
            this.operationNumber = response.data.operationNumber;

            const isAcceptedCommerce = this.meterReadingForm.get('commerceAccepted').value;

            await this.virtualOfficeService.sendInsertPrivacyDataV2({
              "Form": "01",
              "ROW": [
                {
                  "INTERLOCUTOR": data.interlocutorId,
                  "CODIGOCLIENTE": data.clientCode,
                  "FECHA": "",
                  "HORA": "",
                  "CANAL": "LEC",
                  "POLITICAS": [
                    {
                      "TIPO_POLITICA": "03",
                      "ACEPTA": isAcceptedCommerce == true ? 1 : 0
                    }
                  ]
                }
              ]
            });

            //Consumo de servicio de proxima fecha
            this.listNextMeterReadingSchedule(data.clientCode);
            const dialogRef = this.dialog.open(ModalConfirmComponent, {
              data: {
                subject: '¡La operación se realizó de forma exitosa!',
                value: 'N° Operación: ' + this.operationId
              },
              width: '400px',
              autoFocus: false,
              panelClass: 'dialog-custom-2',
              disableClose: true
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.steps = 3;
                this.stepper.next();
              }
            });

            this.steps = 3;
            this.stepper.next();
          } else this.commonService.openErrorDialog([response.message])
        }
      });
    } else {
      let errors = [];
      if (!this.meterReadingForm.get('value').valid) { errors.push('Debe ingresar un monto de consumo válido de hasta 5 dígitos.'); }
      if (!this.meterReadingForm.get('base64Image').valid) { errors.push('Debe seleccionar una imagen válida.'); }
      this.commonService.openErrorDialog(errors);
    }
  }
  async goToSecondStep() {
    if (this.clientForm.valid) {
      let response = await this.virtualOfficeService.getMeterReadingInsertAuthorization(
        this.clientForm.get('documentNumber').value,
        this.clientForm.get('documentType').value,
        this.clientForm.get('clientCode').value,
        this.clientForm.get('captcha').value
      );

      if (response.valid) {

        const dataPrivacityResponse = await this.virtualOfficeService.getPrivacyIsAcceptedByType(
          {
            clientCode: this.clientForm.get('clientCode').value,
            typePolicyCode: "03"
          }
        );

        this.isHiddenCommerce = dataPrivacityResponse.data.length == 0 ? false : true;
        this.installationNumber = response.data.installationNumber;
        this.interlocutorId = response.data.interlocutorId;
        this.fullName = response.data.fullName;
        this.Token = response.data.token;
        this.stepper.next();
        this.steps = 2;
      } else this.commonService.openErrorDialog([response.message])
    } else {
      let errors = [];
      if (!this.clientForm.get('documentType').valid) { errors.push('Debe seleccionar un tipo de documento válido.'); }
      if (!this.clientForm.get('documentNumber').valid) { errors.push('Debe ingresar un número de documento válido.'); }
      if (!this.clientForm.get('clientCode').valid) { errors.push('Debe ingresar un código de cliente válido.'); }
      if (!this.clientForm.get('clauseAccepted').valid) { errors.push('Debe aceptar los Términos y Condiciones.'); }
      if (!this.clientForm.get('captcha').valid) { errors.push('Debe verificar el captcha.'); }
      this.commonService.openErrorDialog(errors);
    }
  }
  getBase64(event) {
    this.notify = false;
    let files = event.target.files;
    if (files.length === 0) {
      return;
    }
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    if (files[0].size <= 5120000) {
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = (_event) => {
        this.meterReadingForm.get('base64Image').patchValue(reader.result);
        this.filename = files[0].name;
      }
      this.imageUpload = reader.result;
    } else this.notify = true;
  }
  async download() {
    let dataPdf = new MeterReadingDownloadPdf(this.operationNumber, this.imageUpload, this.nextDate)
    let response = await this.virtualOfficeService.getMeterReadingRegisterProof(dataPdf);

    if (response.valid) {
      const downloadLink = document.createElement("a");
      const fileName = this.operationId + ".pdf";
      downloadLink.href = 'data:application/pdf;base64,' + response.data.fileContents;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }
  restart() {
    const dialogRef = this.dialog.open(ModalAcceptComponent, {
      data: {
        subject: '¿Está seguro de salir de esta pantalla?'
      },
      width: '400px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.clientForm.reset();
        this.clientForm.get('documentNumber').disable();
        this.clientForm.markAsPristine();
        this.clientForm.markAsUntouched();
        this.clientForm.updateValueAndValidity();
        this.meterReadingForm.reset();
        this.fullName = null;
        this.operationNumber = null;
        this.operationId = null;
        this.stepper.reset();
        this.steps = 1;
      }
    });
  }

  changeStep(event) {
    let index = event.selectedIndex
    this.steps = index + 1;
    if (index == 0) {
      this.title = 'Valida tu datos';
    }
    if (index == 1) {
      this.title = 'Registra tu lectura';
      if (this.showSample) this.openDialogHelp2();
      this.showSample = false;
    }
    if (index == 2) {
      this.title = '¡Listo!';
    }
  }

  prev(stepper: MatStepper) {
    this.openDialogBack('¿Estas seguro de salir de esta pantalla?')
  }

  openDialogView(img: any) {
    const dialogRef = this.dialog.open(ModalViewComponent, {
      width: '900px',
      autoFocus: false,
      panelClass: 'dialog-custom-3',
      data: img
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  openDialogHelp1() {

    if (this.bloqueo) {

      Swal.showLoading();
      Swal.fire({
        title: this.alerta.descHead,
        html: this.alerta.descBody + '</br></br>' + this.alerta.descFoot,
        showClass: {
          popup: 'animate__animated animate__fadeInDown'
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp'
        }
      }).then(f => {
        Swal.hideLoading();
      })
      return;
    }


    const dialogRef = this.dialog.open(ModalHelpInvoiceComponent, {
      width: '800px',
      autoFocus: false,
      panelClass: 'dialog-custom-4'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openDialogHelp2() {
    const dialogRef = this.dialog.open(ModalHelpComponent, {
      autoFocus: false,
      panelClass: 'dialog-custom-1'
    });
    dialogRef.componentInstance.handBookImage = this.handBookImage;
    dialogRef.componentInstance.billImage = this.billImage;
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openDialogAccept(subject) {
    const dialogRef = this.dialog.open(ModalAcceptComponent, {
      data: {
        subject: subject
      },
      width: '400px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.stepper.previous()
        this.steps = 1;
      }
    });
  }

  openDialogBack(subject) {
    const dialogRef = this.dialog.open(ModalBackComponent, {
      data: {
        subject: subject
      },
      width: '400px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.stepper.previous()
        this.steps = 1;
      }
    });
  }

  openDialogConfirm(subject, value?) {
    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      data: {
        subject: subject,
        value: value
      },
      width: '400px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.stepper.next()
        this.steps = 3;
      }

    });
  }

  openDialogSendMail() {
    const dialogRef = this.dialog.open(ModalSendMailComponent, {
      width: '400px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true,
      data: {
        operationNumber: this.operationNumber,
        imageBase64: this.imageUpload,
        operationId: this.operationId,
        nextDate: this.nextDate
      }
    });
  }

  openPoliticas() {
    const dialogRef = this.dialog.open(ModalPoliticasComponent, {
      width: '800px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true
    });
  }

  openTerminos() {
    const dialogRef = this.dialog.open(ModalTerminosComponent, {
      width: '800px',
      autoFocus: false,
      panelClass: 'dialog-custom-2',
      disableClose: true
    });
  }

  soloNumeros(e) {
    var key = window.event ? e.which : e.keyCode;
    if (key < 48 || key > 57) {
      e.preventDefault();
    }
  }

  listNextMeterReadingSchedule(clientCode: string) {
    this.virtualOfficeService.listNextMeterReadingSchedule(clientCode).subscribe(response => {
      if (response.valid) {
        let date = response.data[0].date;
        var dateStringed = date.toString();
        let year = dateStringed.substring(0, 4);
        let month = dateStringed.substring(5, 7);
        let day = dateStringed.substring(8, 10);
        if (dateStringed != "") {
          this.nextDate = day + "/" + month + "/" + year;
        }
        else {
          this.nextDate = "No existe fecha próxima";
        }
      }
    })
    err => {
      console.log("error servicio ListNextMeterReadingSchedule", err);
    };
  }
}